import React from "react";

const ReadyToJoin: React.FC = () => {
  return (
    <section className="secondary-page">
      <div className="max-w-6xl mx-auto">
        <h1>Ready to Join?</h1>
        <h2 className="l0-section-heading">Get in Touch</h2>
        <div className="l0-section-text">
          <ul className="l0-list">
            <li>
              Right now, we’re inviting organisations to join our <b className="l0-emphasis">early access beta platform</b>
              – spots are limited, so get in touch to secure yours!
            </li>
            <li>
              Let us know you’re interested by <b className="l0-emphasis">requesting a referral code</b> and we’ll
              send your organisation our Info Pack.
            </li>
            <li>
              It’s a <b className="l0-emphasis">simple guide</b> with everything you need to know about the platform,
              pricing, and how it works.
            </li>
          </ul>
        </div>

        <h2 className="l0-section-heading mt-5">Register your Organisation</h2>
        <div className="l0-section-text">
          <ul className="l0-list">
            <li>
              Your organisation reviews the pack, signs the agreement, and officially joins
              the <b className="l0-emphasis"><span className="logo-font">LAB ZER0</span> community</b>!
            </li>
          </ul>
        </div>

        <h2 className="l0-section-heading mt-5">Invite Your Labs</h2>
        <div className="l0-section-text">
          <ul className="l0-list">
            <li>Once you’re set up, your organisation’s platform admin can start inviting labs to join and begin their Baseline Assessment!</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ReadyToJoin;
